/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { IonContent, IonHeader, IonPage, IonButton, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonText, IonButtons, IonAlert, IonIcon, IonModal, IonInput } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Toolbar from '../components/Toolbar';
import AlarmModal from '../components/AlarmModal'
import { trash} from 'ionicons/icons';
import './Alarms.scss';

import alarmsData from '../data/alarms.json';

const Alarms: React.FC = (props) => {

  const [t] = useTranslation();
  const [alarms, setAlarms] = useState(alarmsData);
  const [show, SetShow] = useState(false);

  function removeAlarm(alm: any) {
    setAlarms(alarms.filter((alarm: any) => JSON.stringify(alarm) !== JSON.stringify(alm)))
  }

  return (
    <IonPage id="alarm-page">
      <IonHeader>
        <Toolbar title={t('Alarm')} />
      </IonHeader>
      <IonContent fullscreen>
        <div className='dashboard'>
          <div className='alarmHead'>
            <IonText className='ion-hide-md-down ion-float-start'><b>{t('My Alarms')}</b></IonText>
            <IonButton className='ion-float-end' onClick={() => SetShow(true)}>{t('Create')} {t('New')} {t('Alarm')}</IonButton>
          </div><br />
          <div className='alarmList'>
            {
              alarms.map((alarm: any, index: number) => {
                return <IonItem key={index} lines='none'>
                  <IonGrid>
                    <IonRow>
                      <IonCol size='12' size-md='auto'>
                        <IonText><b>{alarm.name}</b></IonText>
                      </IonCol>
                      <IonCol>
                        <IonLabel>
                          {alarm.doseAmount} {alarm.doseUnit}<br />
                          {
                            alarm.date.map((date: string) => {
                              return <IonText key={index + date}>{date}&nbsp;</IonText>
                            })
                          }
                          {t('At')}&nbsp;
                          {
                            alarm.time.map((time: string) => {
                              return <IonText key={index + time}>{time}&nbsp;</IonText>
                            })
                          }
                        </IonLabel>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                  <IonButtons slot='end'>
                    <IonButton color='primary' onClick={() => removeAlarm(alarm)}>
                      <IonIcon slot='icon-only' icon={trash}></IonIcon>
                    </IonButton>
                  </IonButtons>
                </IonItem>
              })
            }
          </div>

        </div>
        <AlarmModal show={show} onClose={() => SetShow(false)} addAlarm={(alarm) => setAlarms([...alarms, alarm])}></AlarmModal>
      </IonContent>
    </IonPage>
  );
};

export default Alarms;
